import {Route} from 'entity-manager';

export enum OrderTypeEnum {
    Work = 'workOrder',
    Service = 'serviceOrder'
}

@Route('order_types')
export class OrderType {
    protected id: string;
    protected code: string;
    protected name: string;
    protected description: string;

    public getId(): string {
        return this.id;
    }

    public setId(id: string) {
        this.id = id;
        return this;
    }

    public getCode(): string {
        return this.code;
    }

    public setCode(code: string) {
        this.code = code;
        return this;
    }

    public getName(): string {
        return this.name;
    }

    public setName(name: string) {
        this.name = name;
        return this;
    }

    public getDescription(): string {
        return this.description;
    }

    public setDescription(description: string) {
        this.description = description;
        return this;
    }
}
